import createLucideIcon from '../createLucideIcon';

const RotateCcw = createLucideIcon('RotateCcwIcon', [
  ['path', { d: 'M3 2v6h6', key: '18ldww' }],
  ['path', { d: 'M3 13a9 9 0 1 0 3-7.7L3 8', key: 'aahkch' }],
]);

export default RotateCcw;
